import script from "./TicTacToeCaptcha.vue?vue&type=script&setup=true&lang=js"
export * from "./TicTacToeCaptcha.vue?vue&type=script&setup=true&lang=js"

import "./TicTacToeCaptcha.vue?vue&type=style&index=0&id=08c67ac2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08c67ac2"]])

export default __exports__